class BLOBList {
  constructor() {
    this.BLOBOid = [];
    this.BlkOfBusId = [];
    this.BlkOfBusName = [];
    this.Description = [];
    this.Address1 = [];
    this.Address2 = [];
    this.Address3 = [];
    this.PostalCode = [];
    this.State = [];
    this.Status = [];
    this.BLOBListResp = null;
  }

  getBLOBOid(index) {
    return this.BLOBOid[index];
  }

  setBLOBOid(index, Oid) {
    this.BLOBOid[index] = Oid;
  }

  getBlkOfBusId(index) {
    return this.BlkOfBusId[index];
  }

  setBlkOfBusId(index, BlkOfBusId) {
    this.BlkOfBusId[index] = BlkOfBusId;
  }
  getBlkOfBusName(index) {
    return this.BlkOfBusName[index];
  }

  setBlkOfBusName(index, BlkOfBusName) {
    this.BlkOfBusName[index] = BlkOfBusName;
  }

  getDescription(index) {
    return this.Description[index];
  }

  setDescription(index, Description) {
    this.Description[index] = Description;
  }

  getAddress1(index) {
    return this.Address1[index];
  }

  setAddress1(index, Address1) {
    this.Address1[index] = Address1;
  }
  getAddress2(index) {
    return this.Address2[index];
  }

  setAddress2(index, Address2) {
    this.Address2[index] = Address2;
  }
  getAddress3(index) {
    return this.Address3[index];
  }

  setAddress3(index, Address3) {
    this.Address3[index] = Address3;
  }
  getPostalCode(index) {
    return this.PostalCode[index];
  }

  setPostalCode(index, PostalCode) {
    this.PostalCode[index] = PostalCode;
  }

  getState(index) {
    return this.State[index];
  }

  setState(index, State) {
    this.State[index] = State;
  }

  getStatus(index) {
    return this.Status[index];
  }

  setStatus(index, Status) {
    this.Status[index] = Status;
  }

  getBLOBListResp() {
    return this.BLOBListResp;
  }

  setBLOBListResp(BLOBListResp) {
    this.BLOBListResp = BLOBListResp;
  }

  resetBLOBList() {
    this.BLOBOid = [];
    this.BlkOfBusId = [];
    this.BlkOfBusName = [];
    this.Description = [];
    this.Address1 = [];
    this.Address2 = [];
    this.Address3 = [];
    this.PostalCode = [];
    this.State = [];
    this.Status = [];
    this.BLOBListResp = null;
  }
}
export default new BLOBList();
